<template>
  <!-- wcześniej klasa full-description -->
  <div v-if="description && description.length" class="content-generator-container">
    <!-- wcześniej klasa content-section -->
    <section v-for="(section, index) in description" :key="index" class="content-row content-row-client">
      <template v-for="(row,indexRow) in section.rows">
        <div v-if="findRowType(row.type)" :key="indexRow" :class="findRowType(row.type).rowClass">
          <div
            v-for="(element, indexColumn) in getColumns(row, findRowType(row.type))"
            :key="indexColumn"
            :class="findRowType(row.type).itemClass"
          >
            <full-description-item
              v-for="(item, indexItem) in getItems(indexColumn, findRowType(row.type))"
              :key="`${row.items[item.index].id}_${indexItem}`"
              :type="item.type"
              :item="row.items[item.index]"
            />
          </div>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import contentGenerator from '~/marketplace-front-core/config/contentGenerator'
import contentGeneratorMixin from '~/marketplace-front-core/mixin/contentGenerator'
import FullDescriptionItem from './FullDescriptionItem'

export default {
  components: { FullDescriptionItem },
  mixins: [contentGeneratorMixin],
  props: {
    description: {
      type: Array,
      default: () => null
    }
  },
  data () {
    return {
      modules: contentGenerator.modules
    }
  },
  methods: {
    findRowType (type) {
      if (type && this.modules && this.modules.length) {
        return this.modules.find(x => x.type === type)
      }
      return null
    }
  }
}
</script>
